import { render, staticRenderFns } from "./largeScreenSort.vue?vue&type=template&id=6b0758b7&scoped=true"
import script from "./largeScreenSort.vue?vue&type=script&lang=js"
export * from "./largeScreenSort.vue?vue&type=script&lang=js"
import style0 from "./largeScreenSort.vue?vue&type=style&index=0&id=6b0758b7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0758b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b0758b7')) {
      api.createRecord('6b0758b7', component.options)
    } else {
      api.reload('6b0758b7', component.options)
    }
    module.hot.accept("./largeScreenSort.vue?vue&type=template&id=6b0758b7&scoped=true", function () {
      api.rerender('6b0758b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/module/otherMarket/views/largeScreenSort.vue"
export default component.exports